
import { Toast } from 'vant'
export default class Tips {
  static loading() {
    Toast.loading({
      mask: true,
      duration: 0,
      message: '加载中...'
    })
  }

  static clear() {
    Toast.clear()
  }

  static error(message = '基础数据错误') {
    Toast.fail({
      message,
      icon: ''
    })
  }

  static success(message = '成功') {
    Toast.success({
      message
    })
  }

  static toast(message = '成功') {
    Toast({
      message
    })
  }
}